var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStampDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "166px",
    height: "122px",
    viewBox: "0 0 166 122",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "stamp-document") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trusted-Contact-icon",
    transform: "translate(-58.000000, -40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "stamp-document",
    transform: "translate(59.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.91358,76.3386073 C156.91358,34.178703 123.372898,0 82,0 C40.6271025,0 7.08641975,34.178703 7.08641975,76.3386073 C7.08641975,87.5718334 9.4874,98.2267945 13.7612198,107.828283 L150.23878,107.828283 C154.5126,98.2267945 156.91358,87.5718334 156.91358,76.3386073",
    id: "Fill-1",
    fill: "#E6F9FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09876543,108.855219 L154.888889,108.855219",
    id: "Stroke-3",
    stroke: "#054C70",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,108.855219 L5.0617284,108.855219",
    id: "Stroke-5",
    stroke: "#054C70",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.938272,108.855219 L164,108.855219",
    id: "Stroke-7",
    stroke: "#054C70",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.62963,117.751272 C133.62963,119.738305 111.647395,121.346495 84.5318594,121.346495 C57.4143331,121.346495 35.4320988,119.738305 35.4320988,117.751272 C35.4320988,115.766133 57.4143331,114.157943 84.5318594,114.157943 C111.647395,114.157943 133.62963,115.766133 133.62963,117.751272",
    id: "Fill-9",
    fill: "#E6F9FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.617284,114.768049 C132.617284,116.100422 131.559837,117.182736 130.253908,117.182736 L70.1905362,117.182736 C68.8846076,117.182736 67.8271605,116.100422 67.8271605,114.768049 L67.8271605,30.2539895 C67.8271605,28.9197077 68.8846076,27.8393021 70.1905362,27.8393021 L119.821426,27.8393021 C120.4473,27.8393021 121.048887,28.0950872 121.491669,28.5455743 L131.924152,39.2045581 C132.368803,39.6569541 132.617284,40.2735107 132.617284,40.9129733 L132.617284,114.768049 Z",
    id: "Fill-11",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.617284,114.768049 C132.617284,116.100422 131.559837,117.182736 130.253908,117.182736 L70.1905362,117.182736 C68.8846076,117.182736 67.8271605,116.100422 67.8271605,114.768049 L67.8271605,30.2539895 C67.8271605,28.9197077 68.8846076,27.8393021 70.1905362,27.8393021 L119.821426,27.8393021 C120.4473,27.8393021 121.048887,28.0950872 121.491669,28.5455743 L131.924152,39.2045581 C132.368803,39.6569541 132.617284,40.2735107 132.617284,40.9129733 L132.617284,114.768049 Z",
    id: "Stroke-13",
    stroke: "#054C70",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.54321,96.6449902 C126.54321,103.45107 121.33055,108.967248 114.901235,108.967248 C108.471919,108.967248 103.259259,103.45107 103.259259,96.6449902 C103.259259,89.8389106 108.471919,84.3207836 114.901235,84.3207836 C121.33055,84.3207836 126.54321,89.8389106 126.54321,96.6449902 Z",
    id: "Stroke-15",
    stroke: "#054C70"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-17",
    stroke: "#05C3DE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "109.333333 95.8236363 113.961374 100.75176 121.481481 91.5093358"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0246914,57.6204469 L120.469136,57.6204469",
    id: "Stroke-19",
    stroke: "#054C70",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0617284,50.4318947 L103.259259,50.4318947",
    id: "Stroke-21",
    stroke: "#054C70",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0246914,64.8089991 L120.469136,64.8089991",
    id: "Stroke-23",
    stroke: "#054C70",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0246914,71.9975513 L120.469136,71.9975513",
    id: "Stroke-25",
    stroke: "#054C70",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.481481,38.9060655 C121.481481,40.1679995 122.490236,41.1894705 123.73404,41.1894705 L133.62963,41.1894705 C133.508187,40.9251599 133.355405,40.6687985 133.145819,40.4541704 L122.208177,29.3571006 C121.998591,29.1464471 121.745912,28.9894506 121.481481,28.8662381 L121.481481,38.9060655 Z",
    id: "Fill-27",
    fill: "#05C3DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.481481,38.9060655 C121.481481,40.1679995 122.490236,41.1894705 123.73404,41.1894705 L133.62963,41.1894705 C133.508187,40.9251599 133.355405,40.6687985 133.145819,40.4541704 L122.208177,29.3571006 C121.998591,29.1464471 121.745912,28.9894506 121.481481,28.8662381 L121.481481,38.9060655 Z",
    id: "Stroke-29",
    stroke: "#054C70",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3377078,111.02112 L28.2055021,111.02112 C27.1633656,111.02112 26.3209877,110.137774 26.3209877,109.049366 L26.3209877,101.450225 C26.3209877,97.092648 29.6961531,93.5632078 33.8590455,93.5632078 L92.6841644,93.5632078 C96.8470568,93.5632078 100.222222,97.092648 100.222222,101.450225 L100.222222,109.049366 C100.222222,110.137774 99.3779597,111.02112 98.3377078,111.02112",
    id: "Fill-31",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4033472,62.0235457 L52.137983,62.0235457 C51.6003811,62.0235457 51.0909751,61.9084724 50.617284,61.728191 C51.7789551,64.202266 54.9481746,72.8461856 54.9481746,93.5632078 L71.5931556,93.5632078 C71.5931556,72.8461856 74.7604953,64.202266 75.9259259,61.728191 C75.450355,61.9084724 74.9409491,62.0235457 74.4033472,62.0235457",
    id: "Fill-33",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.280822,116.720818 C93.9865501,117.6111 93.1565524,118.209672 92.222805,118.209672 L33.3080592,118.209672 C32.3743118,118.209672 31.5443141,117.6111 31.2500422,116.720818 L29.3580247,111.02112 L96.1728395,111.02112 L94.280822,116.720818 Z",
    id: "Fill-35",
    fill: "#05C3DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3377078,111.02112 L28.2055021,111.02112 C27.1633656,111.02112 26.3209877,110.137774 26.3209877,109.049366 L26.3209877,101.450225 C26.3209877,97.092648 29.6961531,93.5632078 33.8590455,93.5632078 L92.6841644,93.5632078 C96.8470568,93.5632078 100.222222,97.092648 100.222222,101.450225 L100.222222,109.049366 C100.222222,110.137774 99.3779597,111.02112 98.3377078,111.02112 Z",
    id: "Stroke-37",
    stroke: "#054C70",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4033472,62.0235457 L52.137983,62.0235457 C51.6003811,62.0235457 51.0909751,61.9084724 50.617284,61.728191 C51.7789551,64.202266 54.9481746,72.8461856 54.9481746,93.5632078 L71.5931556,93.5632078 C71.5931556,72.8461856 74.7604953,64.202266 75.9259259,61.728191 C75.450355,61.9084724 74.9409491,62.0235457 74.4033472,62.0235457 Z",
    id: "Stroke-39",
    stroke: "#054C70",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.280822,116.720818 C93.9865501,117.6111 93.1565524,118.209672 92.222805,118.209672 L33.3080592,118.209672 C32.3743118,118.209672 31.5443141,117.6111 31.2500422,116.720818 L29.3580247,111.02112 L96.1728395,111.02112 L94.280822,116.720818 Z",
    id: "Stroke-41",
    stroke: "#054C70",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6666667,86.3746556 L71.8765432,86.3746556",
    id: "Stroke-43",
    stroke: "#054C70",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1462751,62.755127 L51.3969348,62.755127 C49.2882147,62.755127 47.5802469,61.0276014 47.5802469,58.8990431 L47.5802469,47.0994264 C47.5802469,44.9689401 49.2882147,43.2433425 51.3969348,43.2433425 L75.1462751,43.2433425 C77.2530868,43.2433425 78.962963,44.9689401 78.962963,47.0994264 L78.962963,58.8990431 C78.962963,61.0276014 77.2530868,62.755127 75.1462751,62.755127",
    id: "Fill-45",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1462751,62.755127 L51.3969348,62.755127 C49.2882147,62.755127 47.5802469,61.0276014 47.5802469,58.8990431 L47.5802469,47.0994264 C47.5802469,44.9689401 49.2882147,43.2433425 51.3969348,43.2433425 L75.1462751,43.2433425 C77.2530868,43.2433425 78.962963,44.9689401 78.962963,47.0994264 L78.962963,58.8990431 C78.962963,61.0276014 77.2530868,62.755127 75.1462751,62.755127 Z",
    id: "Stroke-47",
    stroke: "#054C70",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStampDocument);
export default __webpack_public_path__ + "static/media/stamp-document.9399f1ee2907aaea0c71de7866dfeda9.svg";
export { ForwardRef as ReactComponent };